
<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">{{heading}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>

      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="#81DBF6"
      ></v-progress-linear>
    </v-toolbar>
    </v-card>

    <v-alert
      class="my-2"
      dense text
      color="#2A353D"
    >
      <v-row align="center" class="mx-2">
        <v-col class="py-0">
          <v-select
            filled rounded background-color="white" dense
            hide-details max-width="210px"
            v-model="parameters.ClientID"
            :items="allClients.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            @change="getKYCReport()"
            :item-text="item => item.Forename + ` ` + item.MajorName"
            item-value="ClientID"
            placeholder="----"
            label="Client"
          ></v-select>
        </v-col>

        <v-col class="py-0">
          <v-select
            filled rounded background-color="white" dense
            hide-details max-width="210px"
            v-model="parameters.ClientTypeID"
            :items="allClientTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
            class="mx-1"
            @change="getKYCReport()"
            item-text="ClientType"
            item-value="ClientTypeID"
            placeholder="----"
            label="Client Type"
          ></v-select>
        </v-col>

        <v-col class="py-0">
          <v-select
            filled rounded background-color="white" dense
            hide-details max-width="210px"
            v-model="parameters.Status"
            :items="statuses"
            class="mx-1"
            @change="getKYCReport()"
            item-text="text"
            item-value="value"
            placeholder="----"
            label="Status"
          ></v-select>
        </v-col>
      </v-row>
    </v-alert>

    <v-data-table
      :fixed-header="true"
      :headers="headers"
      :items="kyc_report"
      :search="search"
      :height="520"
      hide-default-footer
      disable-pagination
      @current-items="getFiltered"
      class="elevation-12 mt-2"
    >

      <template v-slot:top>
        <v-container row>
          <v-text-field
            class="ml-3"
            hide-details
            outlined
            placeholder="search..."
            v-model="search"
            append-icon="mdi-magnify"
            dense
          ></v-text-field>

          <v-spacer/>

          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
              EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
            </v-btn>
            </template>
            <v-list dense>
            <v-list-item class="ma-0 pa-0">
              <v-btn @click="generatePDF(false)" text small color="#2A353D">
                <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentKYCReport"
                  type    = "xls"
                  name    = "KYC Report.xls">
    
                  <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
                </download-excel>
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentKYCReport"
                  type    = "csv"
                  name    = "KYC Report.csv">
    
                  <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
                </download-excel>
              </v-btn>
            </v-list-item>
            </v-list>
          </v-menu>
          <v-btn @click="generatePDF(true)" outlined small color="#2A353D" class="ml-2" v-on="on">
            PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
          </v-btn>
        </v-container>
      </template>

      <template v-slot:item.DateOpened="{ item }">
        {{ item.DateOpened | moment("DD MMMM YYYY") }}
      </template>

    </v-data-table>
  </v-container>
</template>

<script>
import reportsService from '../services/reports.service';
import UserService from '../services/user.service';
import {mapGetters} from "vuex";
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      parameters: {
        Status: null
      },
      kyc_report: [],
      CurrentKYCReport: [],
      search: '',
      message: '',
      menu: false,
      loading: false,
      heading: "KYC Report",
      menu2: false,
      permitted: null,
      permitted_dialog: true,
      statuses: [
        {value: 0, text: 'Pending Upload'},
        {value: 1, text: 'Uploaded'}
      ],
      headers: [
        {
          text: 'ClientName',
          align: 'start',
          sortable: false,
          value: 'ClientName'
        },
        { text: 'ClientType', value: 'ClientType', sortable: false},
        { text: 'MobileNumber', value: 'MobileNumber', sortable: false },
        { text: 'Email', value: 'Email', sortable: false },
        { text: 'Document', value: 'Document', sortable: false},
        { text: 'Status', value: 'Status', sortable: true}
      ],
    }
  },

  computed: {
    ...mapGetters([
      "currentImage",
      "allClients",
      "allClientTypes",
      "identity",
      "allCountries",
      "allCities"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  methods: {
    getKYCReport() {
      if(this.parameters.ClientID != null && this.parameters.ClientTypeID != null){
        this.loading = true;
        reportsService.getKYCReport(this.parameters)
        .then(response => {
          this.kyc_report = response.data;
          this.loading = false
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false
        })
      }
    },
    generatePDF(IsPrint) {
      const columns = [
        { title: 'ClientName',  dataKey: 'ClientName'},
        { title: 'ClientType', dataKey: 'ClientType'},
        { title: 'MobileNumber', dataKey: 'MobileNumber'},
        { title: 'Email', dataKey: 'Email'},
        { title: 'Document', dataKey: 'Document'},
        { title: 'Status', dataKey: 'Status'}
      ];

      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          var imgData = 'data:image/png;base64,'+ this.currentImage[0].data;

          doc.addImage(imgData, 'PNG', 0.5, 0.28, 1.3, 0.7);
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text(this.identity[0].OrgName, 6.0, 0.5);
          doc.setFontSize(6).text(this.identity[0].Phadd1, 6.0, 0.6);
          doc.setFontSize(6).text(this.allCities.filter(a => a.CityID == this.identity[0].PhCity).map(a => a.City)[0], 6.0, 0.7);
          doc.setFontSize(6).text(this.allCountries.filter(a => a.CountryId == this.identity[0].PhCountry).map(a => a.CountryName)[0], 6.0, 0.8);
          doc.setFontSize(6).text('email: ' + this.identity[0].OrgMail, 6.0, 0.9);
          doc.setFontSize(6).text('cell: ' + this.identity[0].OrgNumber, 6.0, 1.0);
          doc.setFontSize(10).text(this.heading, 0.5, 1.2);
          doc.setFontSize(8).text((this.parameters.ClientID > 0? 'Client: ' + this.allClients.filter(a => a.ClientID == this.parameters.ClientID).map(a => a.Forename) + this.allClients.filter(a => a.ClientID == this.parameters.ClientID).map(a => a.MajorName) + '        ' : '') + (this.parameters.ClientTypeID > 0? 'Client Type: ' + this.allClientTypes.filter(a => a.ClientTypeID == this.parameters.ClientTypeID).map(a => a.ClientType) : ''), 0.5, 1.4);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 1.5, 8, 1.5);
          doc.setLineWidth(0.01).line(0.5, 1.7, 8, 1.7);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        columns,
        body: this.CurrentKYCReport,
        margin: { left: 0.5, top: 1.5 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('KYC Report.pdf')
      }
    },
    getFiltered(current){
      this.CurrentKYCReport = current;
    },
    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },
  },

  mounted () {
    UserService.isReports().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.v-btn {
  outline: none
}
</style>